<template>
  <zg-section>
    <div>
      <h2 v-if="title">
        {{ title }}
      </h2>
      <ul>
        <li
          v-for="(link, index) in linkObjects"
          :key="index"
        >
          <zg-icon icon="link" />
          <a
            v-if="link"
            @click="goToLink(link)"
          >
            {{ link.text }}
          </a>
        </li>
      </ul>
    </div>
  </zg-section>
</template>

<script>
  import ZgSection from '../../ZgSection/ZgSection.vue'
  import ZgIcon from '../../ZgIcon/ZgIcon.vue'

  export default {
    name: 'ZgJumpLinkSection',
    components: {
      ZgSection,
      ZgIcon
    },
    props: {
      title: {
        type: String,
        required: false,
        default: undefined
      }
    },
    data () {
      return {
        linkObjects: []
      }
    },
    mounted () {
      const isStartPage = window.location.pathname === '/'

      setTimeout(() => {
        const tags = Array.from(document.querySelectorAll('.zg-section h2'))
        if (isStartPage) tags.shift()

        tags.forEach((el, index) => {
          const jumplinkId = `jumplinkId${index}`
          el.id = jumplinkId
          const text = el.outerText
          this.linkObjects.push({ jumplinkId, text })
        })

        this.linkObjects = this.linkObjects.filter(tag => tag.text !== this.title)
      }, 150)
    },
    methods: {
      goToLink (link) {
        const margin = 115
        const element = document.getElementById(link.jumplinkId)
        if (!element) return
        const dims = element.getBoundingClientRect()
        window.scrollTo({
          top: dims.top - margin + window.scrollY,
          behavior: 'smooth'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  ul {
    list-style-type: none;
    padding-left: 0;
    display: grid;
    row-gap: rhythm(small);

    @include mq(medium) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: rhythm()
    }

    @include mq(large) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  li {
      display: grid;
      grid-template-columns: auto 1fr;
      column-gap: rhythm('xsmall');
      align-items: center;
    }

  a {
      border-bottom: none;
      cursor: pointer;

      &:hover {
        color: color('brand-500');
      }
  }
</style>
